import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setFormAndTaxYearList, setFormSettings, setImportData, setIsImportDataGridViewLoaded, setLoadingState, setUploadedFilePath } from "./IntegrationsFileImportSlice";
import IntegrationDataService from "../../../../../../services/IntegrationDataService";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../../components/toast/constants";
import FormsDataService from "../../../../../../services/FormsDataService";
import { INTEGRATION_LOADING_STATES } from "../../constants";

export const { getFormAndTaxYearList, UploadAttachment, getLoadImportData, getFormSetting } = {
    getFormAndTaxYearList: (payload) => {
        return {
            type: "INTEGRATION/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    UploadAttachment: (payload) => {
        return {
            type: "INTEGRATION/UPLOAD_ATTACHMENT",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "INTEGRATION/IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "INTEGRATION/GET_FORM_SETTING",
            payload: payload
        }
    },
}

function* getFormAndTaxYearListAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_LOADING_STATES.PAGE_LOADING }));
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setFormAndTaxYearList(response?.data?.Data));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch TaxYear And Form Types", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_LOADING_STATES.PAGE_DATA_READY }));
    }
}
function* UploadAttachmentAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_LOADING_STATES.FILE_UPLOADING }));
        const uploadedFile = action.payload;
        const formData = new FormData();
        formData.append("files", uploadedFile);
        const response = yield IntegrationDataService.uploadFileData(formData);

        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setUploadedFilePath(response?.data?.Data));
            yield put(addNotifications({
                heading: response?.data?.Message,
                message: "File uploaded successfully. You can proceed by clicking on the Next button.",
                variant: TOASTER_VARIANT.SUCCESS
            }));
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Uploaded Data", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_LOADING_STATES.FILE_UPLOADING_READY }));
    }
}
function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_LOADING_STATES.PAGE_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            yield put(setImportData(response?.data?.Data));
            yield put(setIsImportDataGridViewLoaded(true));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: error?.response?.data?.Message }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_LOADING_STATES.PAGE_DATA_READY }));
    }
}
function* getFormSettingAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_LOADING_STATES.PAGE_LOADING }));
        const { formId, year } = action.payload;
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                yield put(setFormSettings(response?.data?.Data));
            } else {
                yield put(addNotifications({ heading: "Error", message: response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: error?.response?.data?.Message, variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_LOADING_STATES.GET_FORM_SETTINGS_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(UploadAttachment().type, UploadAttachmentAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);